import {MuWidget} from "mu-widget/lib/MuWidget";
import {UiTomSelect} from "./UiTomSelect";
import {TomOption} from "tom-select/dist/types/types";
import {UiDms} from "../dms/UiDms";

export class UiOrgProjectSelector extends UiTomSelect
{
	beforeIndex() {
		super.beforeIndex();
		this.muAppendContent(`<div mu-template="item" mu-widget=".">
				<strong mu-bind="name"></strong>
				<em mu-bind="code"></em> |
				<span mu-bind="odName"></span>
				<em mu-bind="odCode"></em> |
				<span mu-bind="acName"></span>
			</div>`
		);
	}

	afterIndex() {
		this.optionLoader = async (query, callback) => {
			const res: TomOption[] = await UiDms.instance.cl.findProjects(query);
			callback(res, []);
		}
		this.searchField = ['code', 'name', 'odName', 'odCode', 'acName'];
		this.init();
	}
}